import React, { Component, CSSProperties, ReactElement } from 'react';

import { arrayOf, element, oneOfType, string } from 'prop-types';
import { animated } from 'react-spring';

import { classNames, isFunction } from '@philips-emr/tws-utils';

import './backdrop.css';

export interface BackdropProps {
  children: ReactElement | ReactElement[];
  className?: string;
  onClick?: () => void;
  style?: CSSProperties;
}

class Backdrop extends Component<BackdropProps> {

  static propTypes = {
    children: oneOfType([element, arrayOf(element)]),
    className: string,
  };

  handleClick = (): void => {
    const { onClick } = this.props;

    isFunction(onClick) && onClick();
  };

  getClassNames(): string {
    const { className } = this.props;

    return classNames({
      'c-backdrop': true,
      [`${className}`]: Boolean(className),
    });
  }

  render(): ReactElement {
    const { children, style } = this.props;

    return (
      <animated.div className={this.getClassNames()} onClick={this.handleClick} style={style}>
        {children}
      </animated.div>
    );
  }
}

export default Backdrop;
